import * as React from 'react';
import ReactPaginate from 'react-paginate';
import Icon from 'modules/Icon';
import PageBody from 'modules/PageBody';

import './style.scss';

interface PaginationProps {
  recordsOnPage: number;
  recordsCount: number;
  pageNumber: number;
  onPageChange: (pageNumber: number) => void;
}

const Pagination = ({ recordsOnPage, recordsCount, pageNumber, ...props }: PaginationProps) => {
  const pagesCount = Math.floor(recordsCount / recordsOnPage);

  const onPageChange = ({ selected }: any) => {
    props.onPageChange(selected + 1);
  };

  const paginationProps = {
    pageCount: pagesCount,
    containerClassName: 'pagination pagination-basic mg-b-0',
    previousLabel: <Icon type="angle-left" />,
    previousClassName: 'page-item',
    previousLinkClassName: 'page-link',
    nextLabel: <Icon type="angle-right" />,
    nextClassName: 'page-item',
    nextLinkClassName: 'page-link',
    pageClassName: 'page-item',
    pageLinkClassName: 'page-link',
    activeClassName: 'active',
    breakClassName: 'page-item disabled',
    breakLinkClassName: 'page-link noselect',
    initialPage: pageNumber - 1,
    onPageChange,
  };

  return (
    <PageBody className="pd-t-0 pd-b-0">
      <div className="d-none d-sm-block">
        <div className="ht-80 d-flex align-items-center justify-content-end ">
          <nav aria-label="Page navigation">
            <ReactPaginate marginPagesDisplayed={2} pageRangeDisplayed={5} {...paginationProps} />
          </nav>
        </div>
      </div>
      <div className="d-block d-sm-none">
        <div className="ht-80 d-flex align-items-center justify-content-center noselect">
          <nav aria-label="Page navigation">
            <ReactPaginate marginPagesDisplayed={0} pageRangeDisplayed={1} {...paginationProps} />
          </nav>
        </div>
      </div>
    </PageBody>
  );
};

export default Pagination;
